import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/mission')({

}).lazy(() => import('./mission.lazy').then((d) => d.Route));
